import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isString } from 'lodash';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import { popApplicationMessage } from '@actions/messages-actions';

class InfoSnackbar extends Component {
  getSnackbarProps = () => {
    const { messages } = this.props;
    const isOpen = messages.length > 0;
    const messageData = messages[0] || '';
    let props = {
      open: isOpen,
      autoHideDuration: 5000,
      onClose: this.props.popMessage,
      anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      style: { bottom: 0 }
    };

    if (isString(messageData)) {
      props.message = messageData;
    } else {
      const { action, onActionTouchTap, message, ...rest } = messageData;
      props = { ...props, ...rest, message };
      // Convert v0.19 action/onActionTouchTap to v4 action button
      if (action && onActionTouchTap) {
        props.action = (
          <Button color="secondary" size="small" onClick={onActionTouchTap}>
            {action}
          </Button>
        );
      }
    }

    return props;
  };

  render() {
    return <Snackbar {...this.getSnackbarProps()} />;
  }
}

InfoSnackbar.propTypes = {
  messages: PropTypes.array,
  popMessage: PropTypes.func
};

const mapStateToProps = state => {
  const { messages } = state;
  return { messages };
};

const mapDispatchToProps = {
  popMessage: popApplicationMessage
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoSnackbar);
